import { render, staticRenderFns } from "./CheckpointResultCard.vue?vue&type=template&id=496cad20&scoped=true"
import script from "./CheckpointResultCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointResultCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointResultCard.vue?vue&type=style&index=0&id=496cad20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496cad20",
  null
  
)

export default component.exports